export function Loader() {
    return (
        <div className="flex items-center justify-center h-[60vh]">
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-muted border-t-brand"></div>
        </div>
    )
}
